// extracted by mini-css-extract-plugin
export default {"mainHeader":"MainHeader_mainHeader__a808+","webTitleContainer":"MainHeader_webTitleContainer__8zZbF","webTitle":"MainHeader_webTitle__ONLT-"};